class Overlay {
  constructor() {
    this.class = 'c-overlay';
    this.id = 'overlay';
    this.openClass = 'c-overlay__open';

    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) { //ESC
        this.close();
      }
    });
  }

  getClass() {
    return this.class;
  }

  open() {
    const overlay = document.createElement("div");
    overlay.className = this.class;
    overlay.setAttribute("id", this.id);
    overlay.addEventListener('click', () => this.close());

    document.body.append(overlay);
    document.body.classList.add(this.openClass);
    document.body.dispatchEvent(new CustomEvent('overlay:show', { bubbles: true, cancelable: true }));
  }

  close() {
    const overlay = document.getElementById(this.id);

    if (overlay) {
      document.getElementById(this.id).remove();
      document.body.classList.remove(this.openClass);
      document.body.dispatchEvent(new CustomEvent('overlay:hide', {bubbles: true, cancelable: true}));
    }
  }
}

const overlay = new Overlay();

export default overlay;
